import './index.css';
import Constants from '../../constants';
import View from '../view';
import React, { CSSProperties } from 'react';
import { isSmartPhone } from '../../utilities/helper';
interface Props {
  children: any;
  source: any;
  className?: string | undefined;
  style?: CSSProperties | undefined;
}
const ScreenImageBackground = ({
  className,
  style,
  source = Constants.Images.cricketTeamPreviewBg,
  children
}: Props) => {
  return (
    <View
      className={`screen_image_container ${className}`}
      style={{
        ...style,
        backgroundImage: `url(${source})`,
        marginBottom: isSmartPhone ? '' : '200px',
        marginTop: isSmartPhone ? '' : '15px'
        // backgroundSize: 'cover'
      }}>
      {children}
    </View>
  );
};

ScreenImageBackground.defaultProps = {
  source: Constants.Images.cricketTeamPreviewBg,
  style: {},
  className: ''
};
export default React.memo(ScreenImageBackground);
